<template>
  <div class="private-trustpilot">
    <top-header yellow />

    <div class="textme private-trustpilot-content">
      <form class="textme-form"
        @submit.prevent="onSubmit">
        <div class="order-title">Sign up form</div>
        <div class="space-between">
          <div class="half-width">
            <input type="text"
              class="textme-form-input"
              v-model="firstName"
              placeholder="First Name"
            />
          </div>
          <div class="half-width">
            <input type="text"
              class="textme-form-input"
              v-model="lastName"
              placeholder="Last Name"
            />
          </div>
        </div>
        <input type="email"
          class="textme-form-input"
          v-model="email"
          placeholder="Email"
        />
        <input type="text"
          class="textme-form-input"
          v-mask="'+1 (###) ###-####'"
          v-model="phoneNumber"
          placeholder="Phone Number"
        />
        <input type="text"
          class="textme-form-input"
          v-model="courseName"
          placeholder="Name of Class(es)or Course Prefixes"
        />
        <div class="space-between">
          <div class="half-width">
            <input type="text"
              class="textme-form-input"
              v-model="totalPriceQuoted"
              placeholder="Total Price Quoted"
            />
          </div>
          <div class="half-width">
            <input type="text"
              class="textme-form-input"
              v-model="AmountDueToday"
              placeholder="Amount due today"
            />
          </div>
        </div>
        <div class="space-between">
          <div class="half-width">
            <input type="text"
              class="textme-form-input"
              v-model="startDate"
              placeholder="Approximate Start Date"
            />
          </div>
          <div class="half-width">
            <input type="text"
              class="textme-form-input"
              v-model="endDate"
              placeholder="Approximate End Date"
            />
          </div>
        </div>
        <select
          class="textme-form-input"
          v-model="hasWorkDueToday"
        >
          <option disabled selected value="">Do you have work due today?</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>
        <textarea
          class="textme-form-textarea"
          v-model="comments"
          placeholder="Instructions, Comments or Requests"
        ></textarea>
        <!-- <vue-recaptcha sitekey="Your key here"></vue-recaptcha> -->
        <div class="textme-form-button-wrapper">
          <button
            :disabled="!firstName || !lastName || !email"
          >SUBMIT</button>
        </div>
      </form>
    </div>

    <app-footer />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader'
import AppFooter from '@/components/AppFooter'

export default {
  components: {
    TopHeader,
    AppFooter
  },
  props: {
    border: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      firstName: null,
      lastName: null,
      email: null,
      phoneNumber: null,
      courseName: null,
      totalPriceQuoted: null,
      AmountDueToday: null,
      startDate: null,
      endDate: null,
      hasWorkDueToday: '',
      comments: ''
    }
  },
  methods: {
    onSubmit () {
      if (this.firstName && this.lastName && this.email) {
        // For Trustpilot submission
        const trustpilotInvitation = {
          recipientEmail: this.email,
          recipientName: this.firstName + ' ' + this.lastName,
          source: 'InvitationScript'
        }
        window.tp('createInvitation', trustpilotInvitation)

        // For mailgun submission
        fetch('/.netlify/functions/sendSignupForOrder', {
          method: 'POST',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            phoneNumber: this.phoneNumber ? this.phoneNumber.replace(/[^0-9.]+/g, '') : '',
            courseName: this.courseName,
            totalPriceQuoted: this.totalPriceQuoted,
            AmountDueToday: this.AmountDueToday,
            startDate: this.startDate,
            endDate: this.endDate,
            hasWorkDueToday: this.hasWorkDueToday,
            comments: this.comments
          })
        })
          .then(response => response.json())
          .then(json => {
            this.$router.push('thank-you-signup')
          })
          .catch((error) => {
            console.log(error)
          })
      }
    }
  }
}
</script>

<style lang="scss">
  @import '~@/styles/media';

  .private-trustpilot-content {
    width: 100%;
    max-width: 600px;
    padding: 40px 60px;
    border: 1px solid#233762;
    margin: 40px auto;
    border-radius: 13px;
    box-shadow: -2.853px 0.927px 8.64px 0.36px rgb(0 0 0 / 9%);

    .order-title {
      font-family: "Mukta Malar", Arial, sans-serif;
      font-style: normal;
      font-weight: 900;
      font-size: 45px;
      text-align: center;
    }

    .space-between {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .half-width {
      width: calc(50% - 4px);
    }

    .submit-result {
      color: var(--primary-green);
      text-align: center;
    }

    button:disabled {
      background-color: #cccccc;
      color: #666666;

      &:hover {
        background-color: #cccccc;
        color: #666666;
      }
    }
  }

  .textme {
    position: relative;

    &-form {
      &-input {
        border-radius: 5px;
        box-sizing: border-box;
        background-color: var(--primary-white);
        height: 49px;
        padding: 5px 20px;
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: center;
        transition: box-shadow .2s ease-out;
        margin-bottom: 15px;
        font-size: 16px;
        border: 1px solid #ddd;
        outline: none;
        width: 100%;

        &:focus {
          box-shadow: var(--basic-shadow);
        }
      }
      &-textarea {
        border-radius: 5px;
        box-sizing: border-box;
        background-color: var(--primary-white);
        height: 49px;
        padding: 15px 20px;
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: center;
        transition: box-shadow .2s ease-out;
        margin-bottom: 15px;
        font-size: 16px;
        border: 1px solid #ddd;
        outline: none;
        width: 100%;
        height: 100px;
        font-family: Arial, Helvetica, sans-serif;

        &:focus {
          box-shadow: var(--basic-shadow);
        }
      }

      &-button-wrapper {
        width: 100%;

        & button {
          width: 100%;
        }
      }

      &-bordered {
        border: 1px solid #dbdbdb;
      }

      &-hovered {
        box-shadow: var(--basic-shadow);
      }

      button {
        background-color: var(--primary-green);
        color: var(--primary-white);
        border-radius: 13px;
        height: 46px;
        outline: none;
        padding: 0 25px;
        border: 0;
        font-size: 14px;
        cursor: pointer;
        transition: background-color .2s ease-out;

        &:hover {
          background-color: var(--primary-green-hover);
        }
      }
    }

    @media #{$xs} {
      input { font-size: 14px; }
      span { display: none; }
    }
  }
</style>
